import "./whatsapp-pricing.css";
import {useState} from "react";
import {BigInput} from "../../components/forms/bigInput/BigInput";
import {Select} from "antd";
import {STARTER} from "./STARTER";
import {GROWTH} from "./GROWTH";
import {SCALE} from "./SCALE";
import {ENTERPRISE} from "./ENTERPRISE";

const PRICING_DATA = [
    STARTER,
    STARTER,
    STARTER,
    GROWTH,
    SCALE,
    ENTERPRISE
];

const WhatsappPricing = () => {
    const [search, setSearch] = useState('');
    const [pricingPlan, setPricingPlan] = useState(2);

    const onChangePricingPlan = (newVal: number) => {
        setPricingPlan(newVal);
    }

    return (
        <div className="whatsapp-pricing-container">
            <h1 className="title">WhatsApp cost per Vuelve message (October 2025)</h1>
            <div className="subtitle">
                <div>The pricing table bellow is based on Whatsapp's pricing document, relevant to June 2023.</div>
                <div>Pricing are up to Meta and might change anytime.</div>
                <div>For updated pricing for a Marketing messages on Whatsapp, please refer to the Meta documentation directly</div>
            </div>
            {/*<div className="join-vuelve" onClick={() => window.location.href = 'https://vuelve.co'}>*/}
            {/*    <img src={VuelveLogo} />*/}
            {/*    <div>Don't let your abandoned carts go away.</div>*/}
            {/*    <div>Join Vuelve to recover your abandoned carts and significantly increase your revenue</div>*/}
            {/*</div>*/}


            <div className="toolbar">
                <Select onChange={onChangePricingPlan} className="pricing-plan-selector" value={pricingPlan}>
                    <Select.Option value={2}>Starter</Select.Option>
                    <Select.Option value={3}>Growth</Select.Option>
                    <Select.Option value={4}>Scale</Select.Option>
                    <Select.Option value={5}>Enterprise</Select.Option>
                </Select>
                <BigInput value={search} setValue={setSearch} placeholder="Search your Region" className="searchbox" />
            </div>

            <div className="pricing-table">
                {PRICING_DATA[pricingPlan].map(pricingData => {
                        const isInKeywords = pricingData.keywords.find(keyword => keyword.toLowerCase().includes(search.toLowerCase()));
                        if(!search || pricingData.country.toLowerCase().includes(search.toLowerCase()) || isInKeywords) {
                            return (
                                <div className="row">
                                    <div className="region">{pricingData.country}</div>
                                    <div className="price">{pricingData.price} <span>USD</span></div>
                                </div>
                            );
                        } else return null;
                    }
                )}
            </div>
        </div>
    )
}

export default WhatsappPricing;